import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { httpClient } from '../restClient';
import CircularProgress from '@material-ui/core/CircularProgress';
import green from '@material-ui/core/colors/green';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const styles = theme => ({
  container: {
    marginTop: "20px",
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: "10px",
    marginRight: "10px",
    width: 300,
  },
  dateField: {
    marginLeft: "10px",
    marginRight: "10px",
    width: 200,
  },
  sendButton:{
    height:"30px",
    width:"150px"
  },
  resultItem:{
    marginTop:"5px"
  },
  resultSection:{
    marginTop:"15px",
    paddingLeft:"10px"
  },
  progressSpinner: {
    color: green[700],
    position: 'absolute'
  },
  topGames:{
    marginTop:"20px",
    cursor:"pointer",
    '&:hover':{
      color:"#d81b60"
    }
  },
  table:{

  }
});

class NumberOfTeamsQuery extends Component {
  state = {
    created_count: false,
    played_count: false,
    teams_count: false,
    from_date: new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().split("T")[0],
    to_date: (new Date).toISOString().split("T")[0],
    top_20_games: false,
    progress: false,
    showTopGames: false
  };

  componentDidMount() {}

  getSummaryCounts = () => {
    var self=this;
    this.setState({created_count: false, played_count: false, teams_count: false, top_20_games: false, progress: true});
    var uri = "/api/business_teams_licence_stats?business_name=" + this.state.business_name + "&from_date=" + this.state.from_date + "&to_date=" + this.state.to_date;
    httpClient(uri, {}).then( (response) => {
        console.dir(response.json);
        response.json.progress = false;
        this.setState(response.json);
      }
    )
  }

  showTopGames = () => {
    this.setState({showTopGames: !this.state.showTopGames})
  }

  handleChange = name => event => {
    let value = event.target.value;
    this.setState({ [name]: value });
  }

  render() {
    //const classes = useStyles();
    const {} = this.state;
    const { classes, width } = this.props;

    console.log("top_20_games: " + this.state.top_20_games)

    return (
      <div>
        <div>
          {"Number of teams of a Business between dates"}
          <form className={classes.container} noValidate>
            <TextField
              id="name"
              label="Company name"
              type="text"
              defaultValue=""
              onChange={this.handleChange("business_name")}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }} />
            <div>
            <TextField
              id="from_date"
              label="From date"
              type="date"
              defaultValue={this.state.from_date}
              onChange={this.handleChange("from_date")}
              className={classes.dateField}
              InputLabelProps={{
                shrink: true,
              }} />
            <TextField
              id="to_date"
              label="Until/Trough date"
              type="date"
              defaultValue={this.state.to_date}
              onChange={this.handleChange("to_date")}
              className={classes.dateField}
              InputLabelProps={{
                shrink: true,
              }} />
            </div>
            <Button
              onClick={this.getSummaryCounts}
              size="small"
              variant="raised"
              color="secondary"
              className={classes.sendButton}
              >
              {"Send"}
            </Button>
          </form>
        </div>
        <div className={classes.resultSection}>
          {this.state.progress && (
            <CircularProgress size={100} className={classes.progressSpinner} />
          )}
          {this.state.created_count && <React.Fragment>
            <div className={classes.resultItem} >{"Total number of games created: " + this.state.created_count}</div>
            <div className={classes.resultItem}>{"Total number of games played: " + this.state.played_count}</div>
            <div className={classes.resultItem}>{"Total number of teams involved in games: " + this.state.teams_count}</div>
          </React.Fragment>}
          {this.state.top_20_games && <div onClick={this.showTopGames} className={classes.topGames}>{"Show top 20 games by teams count"}</div>}
          {this.state.showTopGames &&  
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Creator</TableCell>
                  <TableCell style={{minWidth: "70px"}}>Played date</TableCell>
                  <TableCell>Teams count</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.top_20_games.map(row => (
                  <TableRow key={row.name}>
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell>{row.creator}</TableCell>
                    <TableCell>{row.first_answer}</TableCell>
                    <TableCell>{row.teams_count}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          }
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(NumberOfTeamsQuery);


// WEBPACK FOOTER //
// ./src/dashboard/NumberOfTeamsQuery.js